import React from 'react';
import styled from 'styled-components';
import map from 'lodash/fp/map';

import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';

import { Select } from 'shared/components';
import { USStatesMap } from 'shared/core/constants/geography';
import useCart from 'shared/hooks/use-cart';
import { observer } from 'mobx-react';

const renderStateOptions = map.convert({ cap: false })((longName, shortName) => (
  <option key={shortName} value={shortName}>
    {longName}
  </option>
));

function StateSelect(props) {
  const { error, onValueChange, disabled } = props;
  const Cart = useCart();
  const { customerState } = Cart;
  const hasState = customerState && customerState !== '';

  return (
    <FormControl fullWidth variant='outlined' fluid>
      <StyledInputLabel shrink={hasState} htmlFor='state-selection'>
        Which state do you live in?
      </StyledInputLabel>
      <StyledSelect
        onChange={(e) => {
          Cart.updateCustomerState(e.target.value);
          if (onValueChange) {
            onValueChange();
          }
        }}
        value={customerState || ''}
        id='state-selection'
        backgroundColor='#fcfdfe'
        borderColor='#caced4'
        height={45}
        fontSize={13}
        lineHeight='30px'
        paddingLeft={18}
        error={error}
        disabled={disabled}
        style={{
          alignItems: 'flex-end',
        }}
      >
        <option value='' />
        {renderStateOptions(USStatesMap)}
      </StyledSelect>
    </FormControl>
  );
}

export default observer(StateSelect);

const StyledInputLabel = styled(InputLabel)`
  &.MuiFormLabel-root {
    color: #858788;
    font-size: 13px;
    line-height: 8px;
  }
  &.MuiInputLabel-outlined.MuiInputLabel-shrink {
    transform: translate(18px, 9px) scale(0.75);
  }
`;

const StyledSelect = styled(Select)`
  select {
    line-height: 30px;
  }
`;
